import { Form, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import '@features/Incentive/incentive.css';
import { DashboardSelector } from '../store/DashboardSelector';
import { useEffect, useMemo } from 'react';
import { GetUserDashboard } from '../business/DashboardBusiness';
import Card from 'antd/es/card/Card';
export const UserDashboard = () => {
  const dispatch = useDispatch();
  const dashboardState = useSelector(DashboardSelector);
  const data = useMemo(() => dashboardState.UserDashboardList || [], [dashboardState.UserDashboardList]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'CompleteName',
      key: 'CompleteName',
      sorter: (a, b) => a.CompleteName.localeCompare(b.CompleteName),
    },
    {
      title: 'Username',
      dataIndex: 'Username',
      key: 'Username',
      sorter: (a, b) => a.Username.localeCompare(b.Username),
    },
    {
      title: 'Contact no.',
      dataIndex: 'ContactNo',
      key: 'ContactNo',
    },
    {
      title: 'Address',
      dataIndex: 'CompleteAddress',
      key: 'CompleteAddress',
    },
    {
      title: 'Created date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
    },
    {
      title: 'Account status',
      dataIndex: 'AccountStatus',
      key: 'AccountStatus',
      sorter: (a, b) => a.AccountStatus.localeCompare(b.AccountStatus),
    },
    {
      title: 'How did you hear about us',
      dataIndex: 'HowDidYouHearAboutUs',
      key: 'HowDidYouHearAboutUs',
      sorter: (a, b) => a.HowDidYouHearAboutUs.localeCompare(b.HowDidYouHearAboutUs),
    },
    {
      title: 'Transaction type',
      dataIndex: 'TransactionType',
      key: 'TransactionType',
      sorter: (a, b) => a.TransactionType.localeCompare(b.TransactionType),
    },
  ];
  useEffect(() => {
    const fetchData1 = async () => {
      await dispatch(GetUserDashboard());
    };

    fetchData1();
  }, [dispatch]);

  return (
    <div className="App">
      <Card>
        <Table dataSource={data} columns={columns} pagination={{ pageSize: 100 }} />
      </Card>
    </div>
  );
};
